<app-header [pageTitle]="pageTitle" (back)="backToLeaveSyndicate()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="tom-syndicate">{{syndicateName}}</p>
  </div>
  <div class="lower-content-wrapper">
    <p class="emoji">😧</p>
    <p class="reason-heading">{{'was-not-aware.aware' | translate}}</p>
    <div class="reason-content leave-wrapper">
      <p [innerHTML]="'was-not-aware.number' | translate"></p>
      <button class="blue-link" (click)="closeAndRedirect()">
        {{'was-not-aware.chose' | translate}}
      </button>
    </div>
    <!-- <p class="further-help">Further help:</p>
    <p class="help-question jackpot-trigger-qn">Play when it matters with Jackpot Triggers</p>
    <p class="help-question browse-products">Browse one-off products</p> -->
  </div>
  <ion-row class="lower-most-content">
    <ion-col class="still-leave-wrap">
      <p class="still-leave" (click)="leave()"> {{'was-not-aware.leave' | translate}}</p>
    </ion-col>
  </ion-row>
</ion-content>
